<template>
  <div class="container_self">
    <el-row class="table_parent">
      <h3>AI 生成文章</h3>

      <el-form :model="aiFrom" size="mini" label-width="120px" @submit.native.prevent>
        <el-form-item label="语言">
          <el-select v-model="aiFrom.lang">
            <el-option
              v-for="(item, index) in langs"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="提示词">
          <el-input
            style="max-width: 60%"
            v-model="aiFrom.prompt"
            @keydown.enter.prevent
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 400 }"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="generateArticle"
            v-loading.lock="loading"
            :disabled="loading"
            >生成文章</el-button
          >
        </el-form-item>
      </el-form>

      <el-form :model="addForm" size="mini" label-width="120px" @submit.native.prevent>
        <el-form-item label="内容编辑" style="height: 600px">
          <quill-editor
            v-model="addForm.content"
            ref="myQuillEditor"
            style="height: 520px; width: 100%"
            :options="editorOption"
          >
            <!-- 自定义toolar -->
            <div id="toolbar" slot="toolbar">
              <!-- Add a bold button -->
              <button class="ql-bold" title="加粗">Bold</button>
              <button class="ql-italic" title="斜体">Italic</button>
              <button class="ql-underline" title="下划线">underline</button>
              <button class="ql-strike" title="删除线">strike</button>
              <button class="ql-blockquote" title="引用"></button>
              <button class="ql-code-block" title="代码"></button>
              <button class="ql-header" value="1" title="标题1"></button>
              <button class="ql-header" value="2" title="标题2"></button>
              <!--Add list -->
              <button class="ql-list" value="ordered" title="有序列表"></button>
              <button class="ql-list" value="bullet" title="无序列表"></button>
              <!-- 上传图片 -->
              <button class="ql-image" title="上传图片"></button>
              <!-- Add font size dropdown -->
              <select class="ql-header" title="段落格式">
                <option selected>段落</option>
                <option value="1">标题1</option>
                <option value="2">标题2</option>
                <option value="3">标题3</option>
                <option value="4">标题4</option>
                <option value="5">标题5</option>
                <option value="6">标题6</option>
              </select>
              <select class="ql-size" title="字体大小">
                <option value="10px">10px</option>
                <option value="12px">12px</option>
                <option value="14px">14px</option>
                <option value="16px" selected>16px</option>
                <option value="18px">18px</option>
                <option value="20px">20px</option>
              </select>
              <select class="ql-font" title="字体">
                <option value="SimSun">宋体</option>
                <option value="SimHei">黑体</option>
                <option value="Microsoft-YaHei">微软雅黑</option>
                <option value="KaiTi">楷体</option>
                <option value="FangSong">仿宋</option>
                <option value="Arial">Arial</option>
              </select>
              <!-- Add subscript and superscript buttons -->
              <select class="ql-color" value="color" title="字体颜色"></select>
              <select class="ql-background" value="background" title="背景颜色"></select>
              <select class="ql-align" value="align" title="对齐"></select>
              <button class="ql-clean" title="还原"></button>
              <!-- You can also add your own -->
            </div>
          </quill-editor>
        </el-form-item>
        <el-form-item label="发布域名">
          <el-select v-model="addForm.domain" @change="domainChange">
            <el-option
              v-for="(item, index) in domainList"
              :key="index"
              :label="item.dm"
              :value="item.dm"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题">
          <el-input
            type="text"
            v-model="addForm.title"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="分类">
          <el-select v-model="addForm.categoryIds" multiple>
            <el-option
              v-for="(item, index) in categoryList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="缩略图">
          <el-upload
            drag
            action="https://adminapi.ci-ads.com/api/movie/upload/file"
            style="display: inline-block; margin-left: 15px"
            class="upload-demo"
            :with-credentials="true"
            multiple
            :limit="1"
            ref="uploadImage"
            accept=".jpg,.png,.webp,.jpeg"
            :auto-upload="true"
            :headers="{ Authorization: token }"
            :show-file-list="true"
            :on-success="handleAvatarSuccessImg"
            :file-list="fileList"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
        </el-form-item>

        <el-form-item label="预览缩略图">
          <el-image
            :src="addForm.thumbnail"
            fit="cover"
            :alt="addForm.title"
            :preview-src-list="[addForm.thumbnail]"
            style="width: 100px"
          ></el-image>
        </el-form-item>

        <el-form-item label="发布状态">
          <el-select v-model="addForm.status">
            <el-option
              v-for="(item, index) in status"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="简介">
          <el-input
            type="textarea"
            v-model="addForm.description"
            placeholder="请输入简介"
            :autosize="{ minRows: 5, maxRows: 20 }"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submit" v-loading.lock="loading"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";
import { quillEditor, Quill } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { fetchEventSource } from "@microsoft/fetch-event-source";
//引入font.css
import "@/assets/font.css";
import MarkdownIt from "markdown-it";

const md = new MarkdownIt();

// 自定义字体大小
let Size = Quill.import("attributors/style/size");
Size.whitelist = ["10px", "12px", "14px", "16px", "18px", "20px"];
Quill.register(Size, true);

// 自定义字体类型
var fonts = [
  "SimSun",
  "SimHei",
  "Microsoft-YaHei",
  "KaiTi",
  "FangSong",
  "Arial",
  "Times-New-Roman",
  "sans-serif",
  "宋体",
  "黑体",
];
var Font = Quill.import("formats/font");
Font.whitelist = fonts;
Quill.register(Font, true);

export default {
  name: "FuncFormsEdit",
  components: {
    quillEditor,
  },
  data() {
    return {
      loading: false,
      token: JSON.parse(sessionStorage.getItem("loginData")).token,
      fileList: [],
      addForm: {
        categoryIds: [],
        content: "",
        description: "",
        keywords: [],
        lang: "",
        source: "",
        status: "",
        thumbnail: "",
        title: "",
        writer: "",
        domain: "",
      },
      content: null,
      editorOption: {
        placeholder: "请输入",
        theme: "snow", // or 'bubble'
        modules: {
          toolbar: {
            container: "#toolbar",
          },
        },
      },
      aiFrom: {
        lang: "en",
        prompt: "",
      },
      langs: [
        { label: "中文", value: "zh" },
        { label: "英文", value: "en" },
        { label: "日文", value: "jp" },
        { label: "韩文", value: "kr" },
        { label: "法文", value: "fr" },
        { label: "德文", value: "de" },
        { label: "西班牙文", value: "es" },
        { label: "俄文", value: "ru" },
      ],
      status: [
        { label: "草稿", value: "draft" },
        { label: "发布", value: "publish" },
      ],
      domainList: [],
      categoryList: [],
      articleId: "",
      isEdit: false,
      streamContent: "",
    };
  },
  methods: {
    async generateArticle() {
      this.loading = true;
      await fetchEventSource("https://adminapi.ci-ads.com/api/ai/generate/article/sse", {
        method: "POST", // 支持 POST，不像原生 SSE 只能 GET
        headers: {
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        body: JSON.stringify(this.aiFrom),

        onmessage: (event) => {
          // console.log(JSON.parse(event.data));
          // this.addForm.content += md.render(
          //   JSON.parse(event.data).choices[0].delta.content
          // ); // 持续拼接
          this.streamContent += JSON.parse(event.data).choices[0].delta.content;
        },

        onerror: (err) => {
          console.error("流错误:", err);
        },

        onclose: () => {
          console.log("流关闭");
          this.addForm.content = md.render(this.streamContent);
        },
      });
      this.loading = false;
    },
    handleAvatarSuccessImg(res) {
      if (res.code == 0) {
        this.addForm.thumbnail = res.data.url;
        this.$refs.uploadImage.clearFiles();
        this.$forceUpdate();
      }
    },
    submit() {
      this.addForm.lang = this.aiFrom.lang;
      if (
        !this.addForm.title ||
        !this.addForm.content ||
        !this.addForm.thumbnail ||
        !this.addForm.status
      ) {
        this.$message.error("请填写标题、内容、缩略图、发布状态");
        return;
      }
      this.loading = true;
      let url = this.isEdit ? "/api/cms/article/update" : "/api/cms/article/add";
      axiosPost(url, this.addForm, "JSON").then((res) => {
        if (res.code == 0) {
          this.$message({ message: "发布成功", type: "success" });
          if (this.isEdit) {
            this.restForm();
          }
          this.loading = false;
        } else {
          this.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    domainChange(val) {
      this.addForm.domain = val;
      this.getCategoryList(val);
    },
    getCategoryList(val) {
      axiosGet("/api/cms/category/info", { domain: val }).then((res) => {
        if (res.code == 0) {
          this.categoryList = res.data.length ? res.data : [];
        }
      });
    },
    restForm() {
      this.addForm = {
        categoryIds: [],
        content: "",
        description: "",
        keywords: [],
        lang: "",
        source: "",
        status: "",
        thumbnail: "",
        title: "",
        writer: "",
        domain: "",
      };
      this.aiFrom = {
        lang: "en",
        prompt: "",
      };
    },
  },
  async mounted() {
    this.articleId = this.$route.query.id;
    if (this.articleId) {
      this.isEdit = true;
      await axiosGet("/api/cms/article/content", { id: this.articleId }).then((res) => {
        if (res.code == 0) {
          this.addForm = {
            categoryIds: [res.data.article.categoryIds[0]],
            content: res.data.contents[0].content,
            description: res.data.article.description,
            lang: res.data.article.lang,
            status: res.data.article.status,
            id: res.data.article.id,
            thumbnail: res.data.article.thumbnail,
            title: res.data.article.title,
            domain: res.data.article.domains[0],
          };
          this.aiFrom.lang = res.data.contents[0].lang;
          this.domainChange(res.data.article.domains[0]);
        }
      });
    }
    axiosGet("/api/cms/article/domains").then((res) => {
      if (res.code == 0) {
        this.domainList = res.data.length ? res.data : [];
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/ArticleManager/aiArticle.vue